import { MercuryLiteConfigSchema } from "@redotech/redo-model/conversion/mercury-model";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const createCheckoutSplitGeneration = {
  name: "createCheckoutSplitGeneration" as const,
  input: z.object({
    parentSplitId: zExt.objectId(),
    selectedTreatmentId: zExt.objectId(),
    liteConfig: MercuryLiteConfigSchema.optional(),
  }),
  output: z.object({ newSplitId: zExt.objectId() }),
};
